export default {
    "show-invoice": "Show invoice",
    "show-order": "Show order",
    'invoice-updated-successfully': 'Invoice updated successfully'
}